import dynamic from 'next/dynamic';
import { ShareBySMSProps } from './ShareBySMS.types';

export const ShareBySMS = dynamic<ShareBySMSProps>(() => import(/* webpackPrefetch: true */ './ShareBySms'));
